import { post, get, put, deleteApi } from './axiosFun';

// 题库分页
export const questionPage = (params) => { return post("/edu/question/questionPage", params) };

// 题库列表
export const questionList = (params) => { return post("/edu/question/questionList", params) };
// 题库新增
export const questionAdd = (params) => { return post("/edu/question/questionAdd", params) };

// 题库编辑
export const questionEdit = (params) => { return put("/edu/question/questionEdit", params) };
// 题库删除
export const questionRemove = (params) => { return deleteApi("/edu/question/questionRemove", params) };

// 题库详情
export const questionDetail = (questionId) => { return put(`/edu/question/questionDetail/${questionId}`) };

// 题库导入结果查询
export const importRes = () => { return get(`/edu/question/importRes`) };


// WEBPACK FOOTER //
// ./src/api/topic.js